// extracted by mini-css-extract-plugin
module.exports = {"bigImage":"Hero_bigImage__1465Y","overlay":"Hero_overlay__2g9tD","content":"Hero_content__G3XUD","buttonContainer":"Hero_buttonContainer__vdTSQ","button":"Hero_button__WeDEz"};